/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiButtonComponent = {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides['MuiButton'];
  variants?: ComponentsVariants['MuiButton'];
};

export const ButtonComponent: MuiButtonComponent = {
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      borderRadius: '6px',
      color: CIColors.Tertiary,
      letterSpacing: '-0.011px',
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '14px',
      minWidth: '140px',
      padding: '8px 20px',
      '&:$textPrimary, &:textSecondary': {
        minWidth: '120px',
      },
      '&:hover': {
        color: `${CIColors.Tertiary}DD`,
        fontWeight: 500,
        backgroundColor: 'transparent',
      },
      '&.Mui-disabled': {
        fontWeight: 500,
      },
    },
    sizeSmall: {
      padding: '8px 20px',
      minWidth: 'auto',
      '&:$textPrimary, &:textSecondary': {
        minWidth: 'auto',
      },
    },
    sizeLarge: {
      paddingTop: '12px',
      paddingBottom: '12px',
      minWidth: '220px',
    },
    endIcon: {
      marginRight: '-10px',
      '&$iconSizeSmall': {
        marginRight: '-8px',
      },
    },
    outlined: {
      padding: '',
      border: '2px solid',
      borderColor: CIColors.Tertiary,
      color: CIColors.Tertiary,
      backgroundColor: '#FFFFFF',
      '&:hover': {
        border: '2px solid',
        borderColor: CIColors.Tertiary,
        color: CIColors.Tertiary,
        backgroundColor: `${CIColors.Tertiary}20`,
      },
      '&:disabled': {
        border: '2px solid',
      },
    },
    outlinedError: {
      padding: '',
      border: '2px solid',
      borderColor: CIColors.Error,
      color: CIColors.Error,
      backgroundColor: '#FFFFFF',
      '&:hover': {
        border: '2px solid',
        borderColor: CIColors.Error,
        color: CIColors.Error,
        backgroundColor: `${CIColors.Error}20`,
      },
      '&:disabled': {
        border: '2px solid',
      },
    },
    contained: {
      backgroundColor: CIColors.Tertiary,
      color: '#FFFFFF',
      fontWeight: 800,
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: `${CIColors.Tertiary}DD`,
        fontWeight: 800,
      },
      '&:disabled': {
        fontWeight: 800,
      },
    },
    textSuccess: {
      color: CIColors.Success,
      '&:hover': {
        color: `${CIColors.Success}DD`,
      },
    },
    textError: {
      color: CIColors.Error,
      '&:hover': {
        color: `${CIColors.Error}DD`,
      },
    },
    textSizeSmall: {
      fontSize: '',
    },
    outlinedSizeSmall: {
      fontSize: '',
    },
    containedSizeSmall: {
      fontSize: '',
    },
  },
};
